import { ContactSource, ContactSourceType } from '@mangovoice/types'

export const containsPmsContactSources = (contactSources?: ContactSource[]) => {
  return contactSources?.some(
    (cs) =>
      cs.source !== ContactSourceType.Pbxes &&
      cs.source !== ContactSourceType.Extensions &&
      cs.source !== ContactSourceType.Unknown,
  )
}
